import { useContext } from 'react';
import { DataServiceContext } from '@bingads-webui-campaign-react/smart-page-context';
import { getContextLocale } from '@bingads-webui-campaign-react/smart-component-util';

export const useContextLocale = () => {
  const serverContext = useContext(DataServiceContext);
  const locale = getContextLocale(serverContext);

  return locale;
};
